import localforage from 'localforage';

import { EVERY_DAY } from '../constants';

import type { Cart } from '../types/cart';

const CART_PERSISTENCE_KEY_PREFIX = 'staff-cart:';
const STALE_CART_THRESHOLD_MS = 7 * EVERY_DAY;
const CART_STORAGE_NAME = 'cart-storage';

const cartStorage = localforage.createInstance({
    name: CART_STORAGE_NAME,
    driver: localforage.LOCALSTORAGE,
});

interface PersistedCartEntry {
    cart: Partial<Cart>;
    savedAt: number;
}

function getCartPersistenceKey(staffId: string) {
    return `${CART_PERSISTENCE_KEY_PREFIX}${staffId}`;
}

function isStaleEntry(entry: PersistedCartEntry) {
    return Date.now() - entry.savedAt > STALE_CART_THRESHOLD_MS;
}

export async function saveCartForStaff(staffId: string, cart: Partial<Cart>) {
    const entry: PersistedCartEntry = { cart, savedAt: Date.now() };
    await cartStorage.setItem(getCartPersistenceKey(staffId), entry);
}

export async function getCartForStaff(
    staffId: string,
): Promise<Partial<Cart> | null> {
    const entry = await cartStorage.getItem<PersistedCartEntry>(
        getCartPersistenceKey(staffId),
    );

    if (!entry) {
        return null;
    }

    if (isStaleEntry(entry)) {
        await clearCartForStaff(staffId);

        return null;
    }

    return entry.cart;
}

export async function clearCartForStaff(staffId: string) {
    await cartStorage.removeItem(getCartPersistenceKey(staffId));
}
